import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'

export interface CurrentTimeDisplayProps {
  timezone: string
}

export const CurrentTimeDisplay: React.FC<CurrentTimeDisplayProps> = ({ timezone }) => {
  const [now, setNow] = useState<Date>(() => new Date())

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(new Date())
    }, 30_000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const formattedDate = useMemo(() => {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(now)
  }, [now, timezone])

  const formattedTime = useMemo(() => {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(now)
  }, [now, timezone])

  return (
    <div className={classNames('d-flex align-items-center gap-3 paragraph-medium')}>
      <div className='zocks-text-gray-900'>Current time:</div>
      <div className='zocks-text-gray-900 fw-semibold'>
        {formattedDate} <span className='mx-2'>·</span> {formattedTime}
      </div>
    </div>
  )
}
